import React from 'react';
import ProjectUserContainer from '../../components/ProjectUserComponents/ProjectUserContainer/ProjectUserContainer';
import { UserTypeEnum } from '../../types/enums/UserTypesEnum';

const Captioner = () => {
  return <ProjectUserContainer userType={UserTypeEnum.Captioner} />;
};

export default Captioner;
